// extracted by mini-css-extract-plugin
export default {"grid":"ThumbNailMiniLists_grid__hORCY"};